import { useEffect, useState } from 'react';
import * as api from '../../../api';
import styled from 'styled-components';
import Spinner from '../../../Plateforme/Atoms/Spinner';
import { generateFD100KVDataURL } from '../../Utils/generateFD100KV';
import { supabase } from '../../../lib/supabaseClient';
import { getEventDesignerDisplayName } from '../../../Components/AdminPanels/utils/eventDesignerHelpers';

const Container = styled.div`
    max-width: 1400px;
    margin: 0 auto;
    padding: 20px;
`;

const PageTitle = styled.h1`
    text-align: center;
    font-size: 36px;
    font-weight: 800;
    margin: 40px 0 20px 0;
`;

const ControlPanel = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    margin: 20px 0;
    padding: 20px;
    background: #f5f5f5;
    border-radius: 8px;
`;

const Label = styled.label`
    font-size: 16px;
    font-weight: 600;
    color: #333;
`;

const Select = styled.select`
    padding: 8px 16px;
    font-size: 16px;
    border: 2px solid #e0e0e0;
    border-radius: 6px;
    background: white;
    cursor: pointer;
    transition: border-color 0.2s;

    &:hover {
        border-color: #1833bd;
    }

    &:focus {
        outline: none;
        border-color: #1833bd;
    }
`;

const ImageGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: 25px;
    margin-top: 30px;
`;

const ImageCard = styled.div`
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    padding: 24px;
    background: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
`;

const ImagePair = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

const VersionLabel = styled.p`
    font-size: 12px;
    font-weight: 600;
    color: #666;
    margin: 0 0 8px 0;
`;

const ProjectImage = styled.img`
    width: 100%;
    height: auto;
    border-radius: 8px;
`;

const ErrorMessage = styled.p`
    color: #f44336;
    padding: 12px;
    background: #ffebee;
    border-radius: 4px;
    margin-bottom: 12px;
`;

const EditBadge = styled.span`
    display: inline-block;
    padding: 2px 8px;
    background: #4caf50;
    color: white;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 600;
    margin-left: 8px;
    vertical-align: middle;
`;

const ProjectInfo = styled.div`
    font-size: 12px;
    margin-bottom: 12px;

    .project-name {
        font-weight: 600;
        color: #333;
    }

    .creator-name {
        color: #666;
    }

    .original-value {
        color: #999;
        text-decoration: line-through;
        font-size: 11px;
        margin-left: 4px;
    }

    .project-id {
        color: #999;
        font-size: 10px;
        margin-top: 4px;
    }
`;

const WINNER_PROJECT_IDS = [
    '67a332e21b103d938bafb0dc',
    '67a0b8331b103d938bafa954',
    '67aa1011740d844a3d633e93',
    '6829daa5754f51df2ef9141c',
    '67e6c18043d5609350e381a8',
    '67b5e6146890f1a147192905',
    '67be4a58b1ba28c3144aeb73',
    '67bf2330b1ba28c3144af8d2',
    '67c090dcdb48cb16a13c5b43',
    '677268097ec5d90c89d6fe63',
    '67c6b416db48cb16a13c73c7',
    '67ab652c07736060460b3b75',
    '68348986754f51df2ef9b87c',
    '67d15108d95ccf24eaf191df',
    '67d7d38c43d5609350e242a1',
    '67d82d2243d5609350e24c5e',
    '662adc507159e5b1b1da7c75',
    '67d8718c43d5609350e25c38',
    '67d1977243d5609350e218f2',
    '682b5c5f754f51df2ef93bbc',
    '67da910a43d5609350e274d7',
    '67e1864b43d5609350e2baeb',
    '67daebf343d5609350e27a9e',
    '67dd585043d5609350e28e57',
    '67dfeb0e43d5609350e2a360',
    '67e1452a43d5609350e2b066',
    '678675e2de3ed4a7001ab532',
    '67e2d05943d5609350e2cf97',
    '67e3e1cb43d5609350e304e5',
    '67e3e81543d5609350e308de',
    '67e3f02643d5609350e30a0a',
    '67e42d7043d5609350e32539',
    '67e42e5543d5609350e32570',
    '67e45c9843d5609350e329c0',
    '67e529f743d5609350e33a8c',
    '67e53aab43d5609350e340c3',
    '67e56ab043d5609350e3490f',
    '67e5764d43d5609350e34cb5',
    '67e57f5143d5609350e3519a',
    '67e5864c43d5609350e353a3',
    '67e58da443d5609350e3561d',
    '67e58ebc43d5609350e35665',
    '67e5ab6b43d5609350e35905',
    '67e6828d43d5609350e36b6a',
    '67e6acaf43d5609350e37832',
    '67e51ddb43d5609350e33667',
    '67e6c0a843d5609350e380cf',
    '67e6d53a43d5609350e38725',
    '67e6dfff43d5609350e38900',
    '67e7003c43d5609350e38bfc',
    '6834625c754f51df2ef9a4b1',
    '67ea99b76b7945ed1a576bae',
    '67f90250a0262e085d37088f',
    '67e1741a43d5609350e2b608',
    '67fe7a6c9167c049fff4e37e',
    '67ab6ade07736060460b3c16',
    '6810a343264e7745556acae1',
    '6800f4c59167c049fff51f5d',
    '6800b8529167c049fff50e47',
    '6800e76e9167c049fff5197f',
    '6800ef849167c049fff51c6f',
    '6800fad59167c049fff52224',
    '680113739167c049fff52d73',
    '680106139167c049fff525af',
    '680125219167c049fff53405',
    '680957ab9167c049fff5a7c2',
    '681164d36c8fbfe5e3c91e9e',
    '68020ef79167c049fff54015',
    '68025d069167c049fff56132',
    '680b728c9167c049fff5c8f7',
    '680249249167c049fff55a19',
    '68024ed89167c049fff55b90',
    '68025b1a9167c049fff56037',
    '680270379167c049fff566f5',
    '680274c09167c049fff567c8',
    '680275419167c049fff567de',
    '68027b389167c049fff56954',
    '680291609167c049fff56cad',
    '6802a3fc9167c049fff56f5f',
    '6849787b17dde4ca4c4bf043',
    '6849435a17dde4ca4c4be251',
    '6807cb759167c049fff58dd4',
    '6808c3f59167c049fff599c7',
    '6808c3859167c049fff599b1',
    '680fa4b19167c049fff5deee',
    '6801e2f49167c049fff53ce1',
    '680a54a09167c049fff5bbc4',
    '680b94b29167c049fff5cd49',
    '6810df4a264e7745556ad75d',
    '680fa3f89167c049fff5deb1',
    '680fa844a71ddf126b77b977',
    '680fa9f09167c049fff5e027',
    '6810c9b9264e7745556acf4d',
    '681125b66c8fbfe5e3c91c62',
    '6818cac19e656d77bc6c72fa',
    '6818d27e9e656d77bc6c75a3',
    '6818dbdf9e656d77bc6c78a0',
    '682d97b2754f51df2ef96070',
    '67fccffaa0262e085d370ddc',
    '680271809167c049fff5674a'
];

// WINNER_PROJECT_IDS.length = 5; // Limit to first 5 projects for testing

// Event ID for FD100 2025
const EVENT_ID = '67590da5499bcc995c210b40';

// Convert data URL to Blob for Supabase upload
function dataURLtoBlob(dataUrl) {
    const parts = dataUrl.split(',');
    const mime = parts[0].match(/:(.*?);/)[1];
    const binary = atob(parts[1]);
    const array = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        array[i] = binary.charCodeAt(i);
    }
    return new Blob([array], { type: mime });
}

const FD100KVTest = () => {
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingEdits, setLoadingEdits] = useState(true);
    const [generating, setGenerating] = useState(false);
    const [errors, setErrors] = useState([]);
    const [allProjectsData, setAllProjectsData] = useState([]);
    const [imageMode, setImageMode] = useState('cover');
    const [editedDataMap, setEditedDataMap] = useState({});
    const [generationKey, setGenerationKey] = useState(0); // Used to trigger regeneration
    const [partenaireLogosMap, setPartenaireLogosMap] = useState({}); // projectId -> [{name, type, logoUrl}]
    const [loadingPartenaires, setLoadingPartenaires] = useState(true);
    const [freezing, setFreezing] = useState(false);
    const [freezeProgress, setFreezeProgress] = useState({ done: 0, total: 0 });
    const [freezeResult, setFreezeResult] = useState(null);

    useEffect(() => {
        const fetchProjectData = async () => {
            try {
                // Fetch all participating users with their projects
                const response = await api.getParticipatingUsersProjectData({ eventId: EVENT_ID });

                let _allProjects = [];
                response.data.forEach(user => {
                    if (user.participation.data.projets) {
                        user.participation.data.projets.forEach(project_id => {
                            const project = user.company.projects.find((projet) => projet._id === project_id);
                            if (project && project.status === "validé" && WINNER_PROJECT_IDS.includes(project._id)) {
                                _allProjects.push({
                                    project: project,
                                    user: user
                                });
                            }
                        });
                    }
                });

                setAllProjectsData(_allProjects);
            } catch (error) {
                console.error('Error fetching project data:', error);
                setErrors(prev => [...prev, {
                    projectId: 'general',
                    error: 'Failed to fetch project data: ' + (error.message || 'Unknown error')
                }]);
            } finally {
                setLoading(false);
            }
        };

        fetchProjectData();
    }, []);

    // Fetch edited data from Supabase for all projects
    useEffect(() => {
        if (allProjectsData.length === 0) return;

        const fetchEditedData = async () => {
            setLoadingEdits(true);
            const projectIds = allProjectsData.map(p => p.project._id);

            try {
                const { data: trackingData, error } = await supabase
                    .from('fd100_laureats_tracking')
                    .select('project_id, edited_project_name, edited_creator_name')
                    .in('project_id', projectIds);

                if (!error && trackingData) {
                    const dataMap = {};
                    trackingData.forEach(record => {
                        dataMap[record.project_id] = {
                            projectName: record.edited_project_name,
                            creatorName: record.edited_creator_name
                        };
                    });
                    setEditedDataMap(dataMap);
                }
            } catch (err) {
                console.error('Error fetching edited data from Supabase:', err);
            } finally {
                setLoadingEdits(false);
            }
        };

        fetchEditedData();
    }, [allProjectsData]);

    // Fetch partenaire logos from Supabase
    useEffect(() => {
        const fetchPartenaires = async () => {
            setLoadingPartenaires(true);
            try {
                const { data, error } = await supabase
                    .from('fd100_partenaires')
                    .select('name, type, logo_urls, linked_project_ids')
                    .eq('event_id', EVENT_ID);

                if (!error && data) {
                    const map = {};
                    data.forEach(partenaire => {
                        const logoUrl = partenaire.logo_urls?.[0];
                        if (!logoUrl) return; // Skip partenaires without logos

                        (partenaire.linked_project_ids || []).forEach(projectId => {
                            if (!map[projectId]) map[projectId] = [];
                            map[projectId].push({
                                name: partenaire.name,
                                type: partenaire.type,
                                logoUrl
                            });
                        });
                    });
                    setPartenaireLogosMap(map);
                }
            } catch (err) {
                console.error('Error fetching partenaires:', err);
            } finally {
                setLoadingPartenaires(false);
            }
        };

        fetchPartenaires();
    }, []);

    // Generate images only when project data, edits, and partenaires are loaded
    useEffect(() => {
        if (allProjectsData.length === 0 || loading || loadingEdits || loadingPartenaires) return;

        const generateImages = async () => {
            setGenerating(true);
            // Clear existing images when mode changes or regeneration triggered
            setImages([]);
            setErrors([]);

            for (const projectData of allProjectsData) {
                const editedData = editedDataMap[projectData.project._id] || null;
                const partenaires = partenaireLogosMap[projectData.project._id] || [];
                const hasEdits = editedData !== null && (editedData.projectName || editedData.creatorName);

                // Always generate a base KV (no partenaire logo) for every project
                try {
                    const normalDataUrl = await generateFD100KVDataURL(projectData, false, imageMode, editedData);
                    const invertedDataUrl = await generateFD100KVDataURL(projectData, true, imageMode, editedData);

                    setImages(prev => [...prev, {
                        projectId: projectData.project._id,
                        normalImageUrl: normalDataUrl,
                        invertedImageUrl: invertedDataUrl,
                        hasEdits,
                        editedData,
                        partenaireName: null,
                        partenaireType: null,
                        error: null
                    }]);
                } catch (error) {
                    console.error(`Error generating base KV for project ${projectData.project._id}:`, error);
                    setErrors(prev => [...prev, {
                        projectId: projectData.project._id,
                        error: error.message || 'Unknown error'
                    }]);
                }

                // Additionally generate one KV pair per partenaire with a logo
                for (const partenaire of partenaires) {
                    try {
                        const normalDataUrl = await generateFD100KVDataURL(projectData, false, imageMode, editedData, partenaire.logoUrl, partenaire.name);
                        const invertedDataUrl = await generateFD100KVDataURL(projectData, true, imageMode, editedData, partenaire.logoUrl, partenaire.name);

                        setImages(prev => [...prev, {
                            projectId: projectData.project._id,
                            normalImageUrl: normalDataUrl,
                            invertedImageUrl: invertedDataUrl,
                            hasEdits,
                            editedData,
                            partenaireName: partenaire.name,
                            partenaireType: partenaire.type,
                            error: null
                        }]);
                    } catch (error) {
                        console.error(`Error generating image for project ${projectData.project._id} (${partenaire.name}):`, error);
                        setErrors(prev => [...prev, {
                            projectId: projectData.project._id,
                            partenaireName: partenaire.name,
                            error: error.message || 'Unknown error'
                        }]);
                    }
                }
            }
            setGenerating(false);
        };

        generateImages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading, loadingEdits, loadingPartenaires, imageMode, generationKey]);

    // Freeze all generated KVs: upload to Supabase Storage + save URLs in fd100_frozen_kvs
    const freezeAll = async () => {
        if (!window.confirm('Freeze all KVs? This will upload all generated images to Supabase Storage and store their URLs. Existing frozen KVs for the same project/partenaire will be replaced.')) return;

        setFreezing(true);
        setFreezeResult(null);
        const total = images.length * 2; // normal + inverted per image
        setFreezeProgress({ done: 0, total });

        let successCount = 0;
        let errorCount = 0;

        for (const item of images) {
            for (const version of ['normal', 'inverted']) {
                const dataUrl = version === 'normal' ? item.normalImageUrl : item.invertedImageUrl;
                if (!dataUrl) { errorCount++; continue; }

                try {
                    // Build storage path
                    const safeName = (item.partenaireName || 'base').replace(/[^a-zA-Z0-9]/g, '_');
                    const fileName = `frozen-kvs/${EVENT_ID}/${item.projectId}_${safeName}_${version}.png`;

                    // Upload to Supabase Storage (upsert)
                    const blob = dataURLtoBlob(dataUrl);
                    const { error: uploadError } = await supabase.storage
                        .from('fd100-partenaires-logos')
                        .upload(fileName, blob, { upsert: true, contentType: 'image/png' });

                    if (uploadError) {
                        console.error('Upload error:', uploadError);
                        errorCount++;
                        continue;
                    }

                    // Get public URL
                    const { data: { publicUrl } } = supabase.storage
                        .from('fd100-partenaires-logos')
                        .getPublicUrl(fileName);

                    // Upsert into fd100_frozen_kvs table
                    const { error: dbError } = await supabase
                        .from('fd100_frozen_kvs')
                        .upsert({
                            event_id: EVENT_ID,
                            project_id: item.projectId,
                            partenaire_name: item.partenaireName || '_base_',
                            version,
                            storage_url: publicUrl
                        }, {
                            onConflict: 'event_id,project_id,partenaire_name,version'
                        });

                    if (dbError) {
                        console.error('DB error:', dbError);
                        errorCount++;
                    } else {
                        successCount++;
                    }
                } catch (err) {
                    console.error('Freeze error:', err);
                    errorCount++;
                }

                setFreezeProgress(prev => ({ ...prev, done: prev.done + 1 }));
            }
        }

        setFreezing(false);
        setFreezeResult({ success: successCount, errors: errorCount });
    };

    // Helper to get display name (edited or original) - matches Excel export logic
    const getDisplayProjectName = (projectData) => {
        const edits = editedDataMap[projectData.project._id];
        return edits?.projectName || projectData.project.name_en || projectData.project.name;
    };

    // Helper to get display creator name (edited or original) - matches Excel export logic
    const getDisplayCreatorName = (projectData) => {
        const edits = editedDataMap[projectData.project._id];
        return edits?.creatorName || getEventDesignerDisplayName(projectData.project, projectData.user);
    };

    return (
        <Container>
            <PageTitle>FD100 2025 - KV Test (Frontend Generation)</PageTitle>

            <ControlPanel>
                <Label htmlFor="image-mode">Image Mode:</Label>
                <Select
                    id="image-mode"
                    value={imageMode}
                    onChange={(e) => setImageMode(e.target.value)}
                >
                    <option value="contain">Contain (fit entire image)</option>
                    <option value="cover">Cover (fill area, crop if needed)</option>
                    <option value="debug">Debug (red overlay)</option>
                </Select>
            </ControlPanel>

            {(loading || loadingEdits || loadingPartenaires) && (
                <div style={{ textAlign: 'center', padding: '40px' }}>
                    <Spinner />
                    <p>{loading ? 'Loading project data...' : loadingEdits ? 'Loading edited data...' : 'Loading partenaire logos...'}</p>
                </div>
            )}

            {generating && (
                <div style={{ textAlign: 'center', padding: '20px', background: '#e3f2fd', borderRadius: '8px', marginBottom: '20px' }}>
                    <p style={{ margin: 0, color: '#1976d2' }}>Generating KV images... ({images.length} done)</p>
                </div>
            )}

            {errors.length > 0 && (
                <div>
                    <h3>Errors ({errors.length}):</h3>
                    {errors.map((err, idx) => (
                        <ErrorMessage key={err.projectId + idx}>
                            Project {err.projectId}{err.partenaireName ? ` (${err.partenaireName})` : ''}: {err.error}
                        </ErrorMessage>
                    ))}
                </div>
            )}

            {!loading && (
                <p style={{ textAlign: 'center', color: '#666', marginTop: '20px' }}>
                    Generated {images.length} KV images ({allProjectsData.length} projects)
                </p>
            )}

            {/* Freeze controls */}
            {!generating && images.length > 0 && (
                <div style={{ textAlign: 'center', margin: '20px 0', padding: '20px', background: '#fff3e0', borderRadius: '8px' }}>
                    {freezing ? (
                        <div>
                            <p style={{ margin: '0 0 8px 0', fontWeight: 600, color: '#e65100' }}>
                                Freezing KVs... {freezeProgress.done} / {freezeProgress.total}
                            </p>
                            <div style={{ width: '100%', height: '8px', background: '#ffe0b2', borderRadius: '4px', overflow: 'hidden' }}>
                                <div style={{ width: `${(freezeProgress.done / freezeProgress.total) * 100}%`, height: '100%', background: '#ff9800', borderRadius: '4px', transition: 'width 0.3s' }} />
                            </div>
                        </div>
                    ) : (
                        <button
                            onClick={freezeAll}
                            style={{
                                padding: '12px 32px',
                                background: '#ff9800',
                                color: 'white',
                                border: 'none',
                                borderRadius: '8px',
                                fontSize: '16px',
                                fontWeight: 700,
                                cursor: 'pointer'
                            }}
                        >
                            Freeze All KVs ({images.length * 2} images)
                        </button>
                    )}
                    {freezeResult && (
                        <p style={{ margin: '12px 0 0 0', fontSize: '14px', color: freezeResult.errors > 0 ? '#e65100' : '#2e7d32' }}>
                            Frozen: {freezeResult.success} OK, {freezeResult.errors} errors
                        </p>
                    )}
                </div>
            )}

            <ImageGrid>
                {images.map((item, idx) => {
                    const projectData = allProjectsData.find(p => p.project._id === item.projectId);
                    if (!projectData) return null;

                    const originalProjectName = projectData.project.name_en || projectData.project.name;
                    const originalCreatorName = getEventDesignerDisplayName(projectData.project, projectData.user);
                    const displayProjectName = getDisplayProjectName(projectData);
                    const displayCreatorName = getDisplayCreatorName(projectData);
                    const hasProjectNameEdit = item.editedData?.projectName && item.editedData.projectName !== originalProjectName;
                    const hasCreatorNameEdit = item.editedData?.creatorName && item.editedData.creatorName !== originalCreatorName;

                    const typeLabels = {
                        fabricant: 'Fabricant',
                        ecole: 'École',
                        distributeur: 'Distributeur',
                        editeur: 'Éditeur'
                    };

                    return (
                        <ImageCard key={`${item.projectId}_${item.partenaireName || 'base'}_${idx}`}>
                            <ImagePair>
                                <ProjectInfo>
                                    <div className="project-name">
                                        {displayProjectName}
                                        {hasProjectNameEdit && <EditBadge>EDITED</EditBadge>}
                                    </div>
                                    {hasProjectNameEdit && (
                                        <div className="original-value">Was: {originalProjectName}</div>
                                    )}
                                    <div className="creator-name">
                                        {displayCreatorName}
                                        {hasCreatorNameEdit && <EditBadge>EDITED</EditBadge>}
                                    </div>
                                    {hasCreatorNameEdit && (
                                        <div className="original-value">Was: {originalCreatorName}</div>
                                    )}
                                    {item.partenaireName && (
                                        <div style={{ marginTop: '4px', fontSize: '11px', color: '#1976d2', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <span style={{ background: '#e3f2fd', padding: '1px 6px', borderRadius: '3px', fontWeight: 600, textTransform: 'uppercase', fontSize: '9px' }}>
                                                {typeLabels[item.partenaireType] || item.partenaireType}
                                            </span>
                                            {item.partenaireName}
                                        </div>
                                    )}
                                    {!item.partenaireName && (
                                        <div style={{ marginTop: '4px', fontSize: '11px', color: '#999' }}>
                                            Aucun partenaire avec logo
                                        </div>
                                    )}
                                    <div className="project-id">ID: {item.projectId}</div>
                                </ProjectInfo>
                                <div>
                                    <VersionLabel>Normal</VersionLabel>
                                    <ProjectImage src={item.normalImageUrl} alt={`${displayProjectName} - Normal`} />
                                </div>
                                <div>
                                    <VersionLabel>Inverted</VersionLabel>
                                    <ProjectImage src={item.invertedImageUrl} alt={`${displayProjectName} - Inverted`} />
                                </div>
                            </ImagePair>
                        </ImageCard>
                    );
                })}
            </ImageGrid>
        </Container>
    );
};

export default FD100KVTest;
